import React, { useEffect, useState } from 'react';
import styles from './WidgetFilterDrawer.module.scss';
import { SFButton } from 'sfui';
import { WidgetDrawer } from '../WidgetDrawer/WidgetDrawer';
import { FilterSelector } from '../FilterSelector/FilterSelector';
import { WidgetFilterOption } from '../../../Models';

export interface WidgetFilterDrawerProps {
  title: string;
  defaultChecked: string[];
  options: WidgetFilterOption[];
  isOpen: boolean;
  onClose: () => void;
  onSave: (checked: string[]) => void;
}

export const WidgetFilterDrawer = ({
  title,
  defaultChecked,
  options,
  isOpen,
  onClose,
  onSave
}: WidgetFilterDrawerProps): React.ReactElement<WidgetFilterDrawerProps> => {
  const [checked, setChecked] = useState<string[]>(defaultChecked);

  useEffect(() => {
    if (isOpen) {
      setChecked(defaultChecked);
    }
  }, [defaultChecked, isOpen]);

  return (
    <WidgetDrawer title={title} isOpen={isOpen} onClose={onClose}>
      <FilterSelector
        options={options}
        value={checked}
        onChange={(newChecked: string[]) => setChecked(newChecked)}
      />

      <div className={styles.widgetFilterDrawer}>
        <SFButton fullWidth size="large" onClick={() => onSave(checked)}>
          Save Changes
        </SFButton>
      </div>
    </WidgetDrawer>
  );
};
